function initRaegeboostAnimations() {
    var tl = new TimelineLite();

    var tropfen1 = TweenMax.fromTo('#tropfen4', 1, {
        y: -100,
    }, {
        y: 200,
        transformOrigin: '50% 50%',
        repeat: -1,
        ease: Sine.easeInOut,
    });

    var tropfen2 = TweenMax.fromTo('#tropfen7', 1, {
        y: -60,
    }, {
        y: 200,
        transformOrigin: '50% 50%',
        repeat: -1,
        ease: Sine.easeInOut,
    });

    var tropfen3 = TweenMax.fromTo('#tropfen10', 1, {
        y: -100,
    }, {
        y: 200,
        transformOrigin: '50% 50%',
        repeat: -1,
        ease: Sine.easeInOut,
    });

    var tropfen4 = TweenMax.fromTo('#tropfen11', 1, {
        y: -100,
    }, {
        y: 200,
        transformOrigin: '50% 50%',
        repeat: -1,
        ease: Sine.easeInOut,
    });

    var tropfen5 = TweenMax.fromTo('#tropfen12', 1, {
        y: -100,
    }, {
        y: 200,
        transformOrigin: '50% 50%',
        repeat: -1,
        ease: Sine.easeInOut,
    });

    var tropfen6 = TweenMax.fromTo('#tropfen13', 1, {
        y: -60,
    }, {
        y: 200,
        transformOrigin: '50% 50%',
        repeat: -1,
        ease: Sine.easeInOut,
    });

    var tropfen7 = TweenMax.fromTo('#tropfen14', 1, {
        y: -100,
    }, {
        y: 50,
        transformOrigin: '50% 50%',
        repeat: -1,
        ease: Sine.easeInOut,
    });

    var tropfen8 = TweenMax.fromTo('#tropfen17', 1, {
        y: -100,
    }, {
        y: 100,
        transformOrigin: '50% 50%',
        repeat: -1,
        ease: Sine.easeInOut,
    });

    var tropfen9 = TweenMax.fromTo('#tropfen20', 1, {
        y: -100,
    }, {
        y: 200,
        transformOrigin: '50% 50%',
        repeat: -1,
        ease: Sine.easeInOut,
    });

    tl.add(tropfen1, 0);
    tl.add(tropfen2, '+=0.5');
    tl.add(tropfen3, '-=0.4');
    tl.add(tropfen4, '+=0.9');
    tl.add(tropfen5, '-=0.8');
    tl.add(tropfen6, '+=0.5');
    tl.add(tropfen7, '+=0.5');
    tl.add(tropfen8, '-=0.5');
    tl.add(tropfen9, '+=0.5');
}

$(function () {
    initRaegeboostAnimations();
});



// WEBPACK FOOTER //
// ./static/js/modules/rain-boost.js